import {
    Swiper,
    Navigation,
    Keyboard,
    Autoplay,
} from 'swiper';

Swiper.use([
    Navigation,
    Keyboard,
    Autoplay,
]);

$(window).on('load', function () {
    let desktopTouch = $('.ctaswiper__swiper').data('desktopTouch');
    if (!desktopTouch) {
        desktopTouch = true;
    } else {
        desktopTouch = false;
    }
    let spaceBetween = $('.ctaswiper__swiper').data('spaceBetween');
    if (!spaceBetween) {
        spaceBetween = 30;
    }
    let swiper = new Swiper('.ctaswiper__swiper', {
        slidesPerView: 1,
        spaceBetween: spaceBetween,
        loop: false,
        keyboard: true,
        allowTouchMove: desktopTouch,
        navigation: {
            nextEl: '.ctaswiper__swiper__next',
            prevEl: '.ctaswiper__swiper__prev',
        },
        autoplay: {
            delay: 7500,
        },
    });
    $(window).on('resize', function () {
        if (swiper.initialized) {
            swiper.update();
        }
    });
    window.swipers['ctaswiper'] = swiper;
});
